import React from 'react';
import { format } from 'date-fns';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Pencil, User, ChevronDown } from 'lucide-react';

const toAmPm = (time24) => {
  if (!time24) return '';
  const [hStr, mStr] = time24.split(':');
  let h = parseInt(hStr, 10);
  const suffix = h >= 12 ? 'PM' : 'AM';
  if (h > 12) h -= 12;
  if (h === 0) h = 12;
  return `${h}:${mStr} ${suffix}`;
};

const ReviewStep = ({ services, selectedDate, selectedSlot, notes, onEdit, onContinue, onPickArtist }) => {
  return (
    <div>
      <h4 className="h5 fw-semibold text-center mb-4" style={{ color: '#333' }}>
        Verifique su cita
      </h4>

      <Card style={{ border: '1px solid #FCE4EC', borderRadius: 12 }}>
        <Card.Body className="p-3 p-sm-4">
          {/* Services section */}
          <div className="mb-3">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h6 className="fw-bold mb-0" style={{ fontSize: '0.9rem', color: '#333' }}>Servicios</h6>
              <Button
                variant="link"
                size="sm"
                className="p-0 text-decoration-none d-inline-flex align-items-center gap-1"
                style={{ color: '#EF60A3', fontSize: '0.8rem' }}
                onClick={() => onEdit(1)}
              >
                <Pencil size={12} /> Editar
              </Button>
            </div>

            {services.map((svc, idx) => (
              <div
                key={idx}
                className="d-flex align-items-start justify-content-between py-2"
                style={{ borderBottom: idx < services.length - 1 ? '1px solid #f5f5f5' : 'none' }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p className="mb-1" style={{ fontSize: '0.85rem', color: '#333', overflowWrap: 'anywhere' }}>
                    {svc.label}
                  </p>
                  {onPickArtist ? (
                    <button
                      type="button"
                      onClick={() => onPickArtist(idx)}
                      className="btn btn-sm py-0 px-2 d-inline-flex align-items-center gap-1"
                      style={{
                        fontSize: '0.72rem',
                        border: '1px solid #F8BBD0',
                        color: svc.employeeName ? '#EF60A3' : '#999',
                        backgroundColor: '#FFF0F5',
                        borderRadius: 20,
                      }}
                    >
                      <User size={10} /> {svc.employeeName || 'Elegir artista'} <ChevronDown size={10} />
                    </button>
                  ) : (
                    <Badge
                      bg="light"
                      text="dark"
                      className="fw-normal"
                      style={{ border: '1px solid #e0e0e0', fontSize: '0.72rem' }}
                    >
                      {svc.employeeName || 'Sin preferencia'}
                    </Badge>
                  )}
                </div>
                {svc.price && (
                  <span
                    className="fw-bold flex-shrink-0 ms-3"
                    style={{ fontSize: '0.9rem', color: '#333' }}
                  >
                    {svc.price}
                  </span>
                )}
              </div>
            ))}
          </div>

          <hr style={{ borderColor: '#FCE4EC' }} />

          {/* Date & Time — compact row */}
          <div className="mb-2">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h6 className="fw-bold mb-0" style={{ fontSize: '0.9rem', color: '#333' }}>Fecha y hora</h6>
              <Button
                variant="link"
                size="sm"
                className="p-0 text-decoration-none d-inline-flex align-items-center gap-1"
                style={{ color: '#EF60A3', fontSize: '0.8rem' }}
                onClick={() => onEdit(2)}
              >
                <Pencil size={12} /> Editar
              </Button>
            </div>
            <Row>
              <Col xs={12} sm={4}>
                <p className="mb-0" style={{ fontSize: '0.85rem', color: '#555' }}>
                  {format(selectedDate, 'dd/MM/yyyy')} a las {toAmPm(selectedSlot)}
                </p>
              </Col>
            </Row>
          </div>

          {/* Notes */}
          {notes && (
            <>
              <hr style={{ borderColor: '#FCE4EC' }} />
              <div>
                <h6 className="fw-bold mb-1" style={{ fontSize: '0.9rem', color: '#333' }}>Notas</h6>
                <p className="mb-0 text-muted" style={{ fontSize: '0.85rem' }}>{notes}</p>
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      {/* Navigation */}
      <div className="d-flex justify-content-between mt-4">
        <Button variant="outline-secondary" onClick={() => onEdit(2)}>Atras</Button>
        <Button
          onClick={onContinue}
          style={{
            backgroundColor: '#EF60A3',
            borderColor: '#EF60A3',
            borderRadius: 20,
            padding: '8px 24px',
          }}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
};

export default ReviewStep;
